// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"79":"component---src-templates-index-tsx","296":"ea88be26","532":"styles","774":"framework"}[chunkId] || chunkId) + "-" + {"79":"719cee0c43a1362d5ce5","296":"45ac287d918280ac97c8","532":"f6a66671dc73a22f3b48","774":"d0b4425052f700d432ab","826":"0690513d9776abe49938","932":"f09728bc6d13c512296f"}[chunkId] + ".js";
};